<template>
  <div class="page-container content-430">
    <Form
      ref="searchForm"
      label-position="right"
      :label-width="0"
      class="search-list-430 search-wrapper-430"
    >
      <Row type="flex" flex="end">
        <FormItem label="">
          <Input
            v-model="searchConds.userName"
            placeholder="教师姓名"
            clearable
          ></Input>
        </FormItem>
        <FormItem label="">
          <Input
            v-model="searchConds.phoneNo"
            placeholder="请输入手机号码"
            clearable
          ></Input>
        </FormItem>
        <Button type="primary" @click="handleSearch">确定</Button>
        <Button class="search-430" @click="handleReset">重置</Button>
      </Row>
    </Form>
    <div class="table-title-special-430 flex justify-content_end">
      <div class="top-operate">
        <Button type="primary" @click="exportHandel">导出</Button>
        <EditButton
          v-if="portOrg === 2"
          class="search-430"
          redirect-url="campusServices/basicInfoManagement/facultyManage/Index"
        ></EditButton>
        <!-- <EditButton
          v-if="portOrg === 3"
          class="search-430"
          redirect-url="campusServices/basicInfoManagement/deptManage/Index"
        ></EditButton> -->
      </div>
    </div>
    <div class="main-wrapper">
      <div>
        <Table
          ref="selection"
          border
          :columns="teacherTableColumns"
          :data="teacherData"
        ></Table>
      </div>
      <div class="paging">
        <Page
          :current="pageInfo.pageNum"
          :total="pageInfo.total"
          show-total
          show-elevator
          @on-change="handleChangePage"
        ></Page>
      </div>
    </div>
  </div>
</template>
<script>
import { teacherTableColumns } from '@/pages/assetsModules/manageData.js';
import common from '@/request/common/index.js';
import {
  filterParams,
  downloadReport
} from '@/utils/utils';
import { mapState } from 'vuex';
import EditButton from '@/pages/assetsModules/EditButton';
export default {
  components: {
    EditButton
  },
  data() {
    return {
      teacherTableColumns: [...teacherTableColumns], // 教师列表表格表头
      teacherData: [],
      pageInfo: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      searchConds: {
        userName: null,
        phoneNo: null
      },
      portOrg: -1
    };
  },
  computed: {
    ...mapState(['userInfo']),
    pageTitle() {
      if (this.portOrg === 2) {
        return '教师管理（学校）';
      }
      if (this.portOrg === 3) {
        return '教师管理';
      }
      return '';
    }
  },
  created() {
    this.portOrg = Number(localStorage.getItem('portOrg'));
    this.getTeacherList();
  },
  methods: {
    // 重置搜索词
    handleReset() {
      this.searchConds = {
        userName: null,
        phoneNo: null
      };
    },
    // 点击搜索按钮
    handleSearch() {
      this.pageInfo.pageNum = 1;
      this.getTeacherList();
    },
    handleChangePage(page) {
      this.pageInfo.pageNum = page;
      this.getTeacherList();
    },
    // 获取教师列表
    async getTeacherList() {
      const paramsInfo = {
        schoolId: this.userInfo.orgId,
        pageNum: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize
      };
      const params = { ...paramsInfo, ...this.searchConds };
      const res = await common.getTeacherListNew(params);
      if (res.status === 200) {
        this.teacherData = res.message.list;
        this.pageInfo.total = Number(res.message.total);
      }
    },
    // 导出
    async exportHandel() {
      const data = {
        schoolId: this.userInfo.orgId,
        teacherName: this.searchConds.teacherName,
        teacherPhone: this.searchConds.teacherPhone
      };
      const params = filterParams(data);
      const url = `${process.env.VUE_APP_API_BASESTORE_URL}/teacher/exportAllUserList`;
      downloadReport(url, params);
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
